import { Widget } from "@osjs/widgets";
import "./widget.scss";

export default class MyWidget extends Widget {
  constructor(core, options) {
    super(core, options, {
      // This widget uses a canvas
      canvas: false,
    });

    // create a new dom element to render profile content/dashboard
    this.core = core;
    this.newElement = document.createElement("div");
    this.newElement.className = "osjs-widget-component";
    this.newElement.id = "osjs-react-widget";
    this.$element?.appendChild(this.newElement);

    this.userprofile = core.make("oxzion/profile").get().key;
    this.helper = core.make("oxzion/restClient");
    this.contentType = "";
    this.htmlContent = "";
    this.dashboardUuid = undefined;

    this.fetchUserProfileDashboard();
  }

  fetchUserProfileDashboard = () => {
    this.helper.request("v1", "profile/user/" + this.userprofile.uuid, {}, "get").then((response) => {
      if (response.status === "success") {
        if (response && Object.keys(response).length > 0) {
          if (response.data?.type == "html") {
            this.contentType = "html";
            this.htmlContent = response.data.html;
          } else {
            this.contentType = "dashboard";
            this.dashboardUuid = response.data.dashboard_uuid;
          }
          this.render();
        }
      }
    });
  };

  onContextMenu(ev) {
    // Prevent the default context menu
    ev.preventDefault();
    // Stop the event from bubbling up
    ev.stopPropagation();
    // Return false to prevent the original handler from executing
    return false;
  }

  // When widget is destructed
  onDestroy() {}

  // When widget was resized
  onResize() {}

  // When widget was moved
  onMove() {}

  render() {
    if (this.contentType !== "") {
      const React = oxziongui.React;
      const $reactRoot = oxziongui.ReactDOM.createRoot(this.newElement);
      $reactRoot.render(
        this.contentType === "html" ? (
          <oxziongui.JsxParser
            autoCloseVoidElements
            jsx={this.htmlContent}
            bindings={{
              data: {},
              profile: this.userprofile,
            }}
          />
        ) : (
          this.contentType === "dashboard" && (
            <oxziongui.DashboardManager
              uuid={this.dashboardUuid}
              content={{ uuid: this.dashboardUuid }}
              args={this.core}
              hideEdit={true}
              dashboardoperations={null}
              customActions={null}
            />
          )
        ),
      );
    }
  }
}
